export default "__VITE_ASSET__CG3$Myh4__"